import { useInfiniteQuery } from '@tanstack/react-query';
import { ComponentProps } from 'preact/compat';

import { cn } from '@/lib/utils';
import { getInfiniteMediaQueryOptions, InfiniteMediaQuerySearchParams } from '@/queries/media';

interface EmbeddedHabitatMediaGridProps extends ComponentProps<'ul'> {
  mediaQueryParams: InfiniteMediaQuerySearchParams;
  pageSize: number;
}

const EmbeddedHabitatMediaGrid = ({ mediaQueryParams, pageSize, className, ...props }: EmbeddedHabitatMediaGridProps) => {
  const { data, isLoading } = useInfiniteQuery(getInfiniteMediaQueryOptions(mediaQueryParams));

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <ul className={cn('preflight preflight-ul empty:hidden', className)} {...props}>
      {data?.list.slice(0, pageSize).map((media) => (
        <li key={media._id}>
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a
            href={`/media/${media.slugPrefix || 'media'}-${media._id}`}
            target="_blank"
            className="preflight preflight-a block"
          >
            <div className="preflight relative overflow-hidden rounded desktop:rounded-lg">
              <img
                className="preflight preflight-img aspect-video"
                src={media.thumbnailURL}
                alt={media.title}
                loading="lazy"
              />
            </div>
          </a>
        </li>
      ))}
      {isLoading &&
        Array.from({ length: pageSize }).map((_, index) => (
          <li key={`placeholder-${index.toString()}`}>
            <div className="preflight skeleton relative aspect-video overflow-hidden rounded bg-grey-5 desktop:rounded-lg" />
          </li>
        ))}
    </ul>
  );
};

export default EmbeddedHabitatMediaGrid;
